if (!customElements.get('countdown-timer-bar')) {
  customElements.define(
    'countdown-timer-bar',
    class CountdownTimerBar extends HTMLElement {
      connectedCallback() {
        this.durationMs = (parseInt(this.dataset.duration, 10) || 600) * 1000;
        this.daysEl = this.querySelector('[data-unit="days"]');
        this.hoursEl = this.querySelector('[data-unit="hours"]');
        this.minutesEl = this.querySelector('[data-unit="minutes"]');
        this.secondsEl = this.querySelector('[data-unit="seconds"]');
        this.endTime = Date.now() + this.durationMs;
        this.tick();
        this.intervalId = setInterval(this.tick.bind(this), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.intervalId);
      }

      tick() {
        let remaining = this.endTime - Date.now();

        while (remaining <= 0) {
          this.endTime += this.durationMs;
          remaining = this.endTime - Date.now();
        }

        const days = Math.floor(remaining / 86400000);
        const hours = Math.floor((remaining % 86400000) / 3600000);
        const minutes = Math.floor((remaining % 3600000) / 60000);
        const seconds = Math.floor((remaining % 60000) / 1000);

        this.daysEl.textContent = String(days).padStart(2, '0');
        this.hoursEl.textContent = String(hours).padStart(2, '0');
        this.minutesEl.textContent = String(minutes).padStart(2, '0');
        this.secondsEl.textContent = String(seconds).padStart(2, '0');
      }
    }
  );
}
